<script>
  import {afterUpdate, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import HouseTiler from '../components/HouseTiler.svelte'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import ViewSource from '../components/ViewSource.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'

  let anim = {houseTo105: 0}

  let clientWidth, clientHeight, numEl, housesSectionEl,
    houseTilerAnim, houseTilerTrigger, lastHouseCount = 0;

  $: houseNum = Math.round(anim.houseTo105) + 'M'

  afterUpdate(() => {
    const houses = document.querySelectorAll('#part2-house-tiles .house')
    if(lastHouseCount && lastHouseCount !== houses.length) updateHouseTilerAnim()
    
  })

  onDestroy(() => {
    houseTilerTrigger?.kill()
    houseTilerAnim?.kill()
  })
  
  function updateHouseTilerAnim () {
    const houses = document.querySelectorAll('#part2-house-tiles .house')
    const houseRows = document.querySelectorAll('#part2-house-tiles .row')
    if(lastHouseCount === houses.length) return

    houseTilerTrigger?.kill()
    houseTilerAnim?.kill()
    houseTilerAnim = gsap.timeline()
    lastHouseCount = houses.length
    houseRows.forEach((row, rowIndex) => {
      row.querySelectorAll('.house').forEach(house => {
        const delay = (houseRows.length - rowIndex) * .2 + Math.random() * .5
        houseTilerAnim.fromTo(house, {opacity: 0}, {opacity: 0.4, ease: 'none', duration: 0.5}, delay)
      })
    })
    const duration = houseTilerAnim.duration()
    houseTilerAnim.fromTo(numEl,
      {opacity: 0},
      {
        opacity: 1,
        ease: 'none',
        duration: 0.75,
        onUpdate: () => {
          const pct = gsap.getProperty(numEl, 'opacity')
          anim.houseTo105 = Math.round(pct * 105)
          anim = anim
        }
      },
    duration - 1.5)
    houseTilerAnim.add(()=>{}, '+=.5')
    
    houseTilerTrigger = ScrollTrigger.create({
      trigger: housesSectionEl,
      scrub: 0.6,
      pin: true,
      anticipatePin: true,
      start: 'top bottom',
      end: 'bottom bottom',
      id: 'houseTiles',
      animation: houseTilerAnim,
      pinSpacing: false
    })
  }

</script>
<section class="part2" data-width={clientWidth}>
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedTitle size={1} class="large" style="maskup"><span class="accent">As</span> <span class="accent">cord-cutting</span> <span class="accent">has</span> <span class="accent">increased,</span> the adoption of CTV has grown exponentially.</AnimatedTitle>
      <AnimatedTitle size={1} delay={0.5}>Connected TV households are projected to rise to 105 million, representing 81% of households.</AnimatedTitle>
      <AnimatedBlock delay={0.75}>
        <ViewSource id="ctv_projected_rise_105m">eMarketer</ViewSource>
      </AnimatedBlock>
    </div>
  </div>
  <div class="full-width houses-outer">
    <div class="measure" bind:clientWidth={clientWidth}>{clientWidth}</div>
    <div class="house-bg" bind:this={housesSectionEl}>
      <div class="houses-inner" bind:clientHeight={clientHeight}>
        <div class="num" bind:this={numEl}>{houseNum}</div>
        <HouseTiler id="part2-house-tiles" width={clientWidth} height={clientHeight} on:redraw={updateHouseTilerAnim} />
      </div>
    </div>
  </div>
</section>

<style>
  .part2 .house-bg,
  .houses-inner {
    position: relative;
    height: 800px;
  }
  .houses-inner {
    transform: translateY(-800px);
    pointer-events: none;
  }
  .houses-outer {
    margin-top: 60px;
    padding-bottom: 8px;
  }
  .part2 .house-bg .num {
    text-align: center;
    font-size: 114px;
    font-weight: bold;
    position: absolute;
    top: calc(50% + 40px);
    left: 0;
    width: 100%;
    z-index: 1;
    transform: translateY(-50%);
  }
  @media(min-width: 450px) and (max-height: 900px) {
    .part2 .house-bg .num {
      top: calc(50vh + 80px)
    }
  }
  .measure {
    overflow: hidden;
    height: 0;
    opacity: 0;
  }
  @media(min-height: 800px) and (max-width: 490px) {
    .part2 .house-bg,
    .houses-inner {
      height: 100vh;
    }
    .houses-inner {
      transform: translateY(-100vh);
    }
  }
  @media(min-width: 768px) {
    .part2 .house-bg,
    .houses-inner {
      height: 100vh;
    }
    .houses-inner {
      transform: translateY(-100vh);
    }
    .part2 .house-bg .num {
      font-size: 200px;
    }
    .houses-outer {
      margin-top: 250px;
    }
  }
  @media(min-width: 1024px) {
    .part2 .house-bg .num {
      font-size: 268px;
    }
  }
  
</style>